import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { hideModal, showModal } from 'actions/modal';
import { CONFIRM_MODAL, DISMISS_MODAL } from 'constants/shared/modalTypes';
import {
    PAYMENT,
    PAYMENT_ADD_PAYEE,
    PAYMENT_MANAGE_PAYEES,
} from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import ManagePayees from '../presentational/ManagePayees';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';
import { trackCustomerIOEvent } from 'utils/customerIO';
import { CustomerIOEvent } from 'lib/type';
import { useDeletePayeeMutation, useGetPayeesQuery } from 'lib/services';

const ManagePayeesContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { data: payees, isFetching, error } = useGetPayeesQuery();
    const [deletePayee, { error: deleteError }] = useDeletePayeeMutation();

    const translate = useTranslate('managePayees');

    const handleAddNewPayee = () => {
        history.push(PAYMENT_ADD_PAYEE, {
            backRoute: PAYMENT_MANAGE_PAYEES,
        });
    };

    const handleDelete = payee => {
        dispatch(
            showModal({
                type: CONFIRM_MODAL,
                props: {
                    title: translate('removePayee'),
                    message: translate('confirmationMessage'),
                    handleSubmit: async () => {
                        dispatch(hideModal());
                        await deletePayee(payee.id).unwrap();
                        trackCustomerIOEvent(CustomerIOEvent.DELETE_PAYEE, {
                            payeeName: payee.payeeName,
                            type: payee.type,
                        });
                    },
                },
            }),
        );
    };

    useEffect(() => {
        const handleDeleteError = () => {
            if (deleteError) {
                dispatch(
                    showModal({
                        type: DISMISS_MODAL,
                        props: {
                            title: translate('removePayee'),
                            message: translate('errorDeleteError'),
                            handleCancel: () => {
                                dispatch(hideModal());
                            },
                        },
                    }),
                );
            }
        };

        if (deleteError) {
            dispatch(hideModal());
            handleDeleteError();
        }
    }, [deleteError, translate, dispatch]);

    return (
        <PageContainer className="manage-payee-container">
            <SectionTitle title={translate('titleText')} backRoute={PAYMENT} />
            <DataCheck data={payees} isLoading={isFetching} error={error}>
                <ManagePayees data={payees} handleDelete={handleDelete} />
            </DataCheck>
            <ButtonContainer>
                <Button onClick={handleAddNewPayee} className="center">
                    {translate('addNewPayee')}
                </Button>
            </ButtonContainer>
        </PageContainer>
    );
};

export default ManagePayeesContainer;
